import { tv } from 'tailwind-variants'

export const mediaCardVariants = tv({
  slots: {
    container: 'flex flex-col'
  }
})
